import classNames from 'classnames'
// import { platformProducts } from 'config/platform'
import getConfig from 'next/config'
import CustomImage from 'src/components/Image'
import useAppStore from 'src/hooks/business/use_app_store'
import useI18n from 'src/hooks/use_i18n'

import { useMemo } from 'react'
import styles from './index.module.scss'

const { publicRuntimeConfig } = getConfig()
const assetPrefix = publicRuntimeConfig.assetPrefix || ''

export default function Product({ platform }: { platform: string }) {
  const { $t, activeLocale: locale, i18nFormatAll } = useI18n()
  const { stores, browserInfoRef } = useAppStore()
  const source = platform ? 'brands' : 'tracking'

  const appHref = useMemo(() => {
    if (browserInfoRef.isAndroid) {
      return `${stores[1].link}&utm_source=${source}&utm_medium=referer&utm_campaign=20250214-${source}-open-app`
    }

    if (browserInfoRef.isIos) {
      return `${stores[0].link}?utm_source=${source}&utm_medium=referer&utm_campaign=20250214-${source}-open-app`
    }
    return `//www.17track.net/${locale}/app?utm_source=${source}&utm_medium=referer&utm_campaign=20241029-${source}-open-app`
  }, [stores])

  const platformProducts = [
    {
      text: platform
        ? i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pWhatCanIDo_shopifyText'), {
            carriersName: platform
          })
        : 'An order tracking App built for Shopify sellers, keeping track of buyer packages.',
      buttonText: $t('ResCarrierListPSeoDetails.global.__pWhatCanIDo_shopifyButton'),
      href: `/${locale}/track_page?utm_source=www.17track.net&utm_medium=${source}&utm_campaign=Get-started`,
      img: assetPrefix + '/assets/images/platform/product_shopify',
      alt: `Use the 17TRACK Shopify APP to track your ${platform} packages.`
    },
    {
      text: platform
        ? i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pWhatCanIDo_apiText'), {
            carriersName: platform
          })
        : 'Tracking API makes auto track & trace and webhook push a breeze.',
      buttonText: $t('ResCarrierListPSeoDetails.global.__pWhatCanIDo_apiButton'),
      href: `//www.17track.net/${locale}/api?utm_source=${source}&utm_medium=referer&utm_campaign=20241029-${source}-open-api`,
      img: assetPrefix + '/assets/images/platform/product_api',
      alt: `Use the 17TRACK API to track your ${platform} packages.`
    },
    {
      text: platform
        ? i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pWhatCanIDo_appText'), {
            carriersName: platform
          })
        : 'Get real-time notifications on package delivery updates.',
      buttonText: $t('ResCarrierListPSeoDetails.global.__pWhatCanIDo_appButton'),
      href: appHref,
      img: assetPrefix + '/assets/images/platform/product_app',
      alt: `Use the 17TRACK API to track your ${platform} packages.`
    }
  ]

  const handleClick = (index: number) => {
    // app 产品跳转埋点
    if (index === 2) {
      if (browserInfoRef.isAndroid) {
        return window.ga?.sendEvent?.('事件操作', `${source}-跳转google play`)
      }

      if (browserInfoRef.isIos) {
        return window.ga?.sendEvent?.('事件操作', `${source}-跳转app store`)
      }
      window.ga?.sendEvent?.('事件操作', `${source}-点击跳转app落地页`)
    }
  }

  return (
    <section className={styles.product}>
      {platformProducts.map((item, index) => {
        return (
          <div className={styles.productItem} key={index}>
            <div className={styles.cardImg}>
              <CustomImage
                loading="lazy"
                width={237}
                height={160}
                className="lazy-image-fill"
                isWebp={false}
                src={item.img}
                alt={item.alt}
                // errorSrc="https://res.17track.net/asset/carrier/logo/120x120/0"
              />
            </div>
            <span>{item.text}</span>
            <a target="_blank" href={item.href} onClick={handleClick.bind(null, index)}>
              <span>{item.buttonText}</span>
              <i className={classNames('icon fa-arrow-forward', styles['fa-arrow-forward'])}></i>
            </a>
          </div>
        )
      })}
    </section>
  )
}
